export default __webpack_public_path__ + "static/media/bank-jcb-square.3f344691.svg";